import { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';

const getCountdownState = startTime => {
  const now = dayjs();
  const start = dayjs(startTime);
  const diff = start.diff(now, 'second');

  if (diff <= 0) {
    const overdueMinutes = Math.floor(Math.abs(diff) / 60);
    const overdueSeconds = Math.abs(diff) % 60;
    return {
      timeLeft: `${overdueMinutes}:${overdueSeconds.toString().padStart(2, '0')}`,
      isOverdue: true,
    };
  }

  return {
    timeLeft: `${Math.floor(diff / 60)}`,
    isOverdue: false,
  };
};

const CountdownTimer = ({ startTime }) => {
  const [{ timeLeft, isOverdue }, setCountdown] = useState(() => getCountdownState(startTime));

  useEffect(() => {
    const updateTimer = () => {
      const nextCountdown = getCountdownState(startTime);
      setCountdown(currentCountdown =>
        currentCountdown.timeLeft === nextCountdown.timeLeft &&
        currentCountdown.isOverdue === nextCountdown.isOverdue
          ? currentCountdown
          : nextCountdown
      );
    };

    updateTimer();

    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return (
    <Typography
      variant='body2'
      sx={{
        color: isOverdue ? 'error.main' : 'text.secondary',
        fontSize: {
          xs: '1rem', // For screens smaller than 1000px
          sm: '1.2rem', // For screens between 1000px and 1300px
          md: '1.4rem', // For screens larger than 1300px
        },
      }}
    >
      {isOverdue ? (
        <>
          Seit{' '}
          <Box component='span' sx={{ fontWeight: '1000' }}>
            {timeLeft} Minuten
          </Box>{' '}
          überschritten
        </>
      ) : (
        <>
          Noch{' '}
          <Box component='span' sx={{ fontWeight: '1000' }}>
            {timeLeft} Minuten
          </Box>
        </>
      )}
    </Typography>
  );
};

export default CountdownTimer;
